import { Injectable } from '@angular/core';

export interface PostAuthOptions {
  redirectUri: string;
  code?: string;
  customUrlRedirect?: string;
  redirectTo?: string;
  additionalParams?: Record<string, string>;
}

const ALLOWED_DOMAINS = [
  /\.aprova\.com\.br$/,
  /\.prefeituras\.net$/,
  /\.bbgovernodigital\.com\.br$/,
  'localhost',
  'prefeitura',
  'acelera.canoas.rs.gov.br',
  /(^|\.)lusia\.niteroi\.rj\.gov\.br$/,
];

@Injectable({ providedIn: 'root' })
export class RedirectService {
  /** Navegação de página inteira para o authorize de um provedor externo. */
  toProvider(authorizeUrl: string): void {
    window.location.href = authorizeUrl;
  }

  postAuth({ redirectUri, code, customUrlRedirect, redirectTo, additionalParams }: PostAuthOptions): void {
    if (redirectTo) {
      if (this.isAbsoluteUrl(redirectTo) && this.isAllowedDomain(redirectTo)) {
        const params = new URLSearchParams({ ...(code ? { code } : {}), ...(additionalParams ?? {}) });
        window.location.href = `${redirectTo}?${params.toString()}`;
        return;
      } else if (this.isAllowedDomain(redirectUri)) {
        window.location.href = `${redirectUri}?code=${code}&redirectTo=${encodeURIComponent(redirectTo)}`;
        return;
      }
    }

    let finalUri = redirectUri;
    if (customUrlRedirect) {
      const customOrigin = new URL(customUrlRedirect).origin;
      const responsePath = new URL(redirectUri).pathname;
      finalUri = `${customOrigin}${responsePath}`;
    }

    if (!this.isAllowedDomain(finalUri)) {
      throw new Error('Invalid redirect URL');
    }

    window.location.href = code ? `${finalUri}?code=${code}` : finalUri;
  }

  private isAbsoluteUrl(url: string): boolean {
    const httpRegex =
      /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
    return httpRegex.test(url);
  }

  /** Público porque o botão de voltar do layout valida por aqui — a allowlist é uma só. */
  public isAllowedDomain(url: string): boolean {
    try {
      const { hostname } = new URL(url);
      return ALLOWED_DOMAINS.some((allowedDomain) =>
        allowedDomain instanceof RegExp
          ? allowedDomain.test(hostname)
          : allowedDomain === hostname
      );
    } catch {
      return false;
    }
  }
}
